import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { SignedIn, SignedOut, RedirectToSignIn, UserButton, useAuth } from '@clerk/clerk-react';
import './App.css';
import LandingPage from './components/LandingPage';
import LoginSuccess from './components/LoginSuccess';
import StripeSuccess from './components/StripeSuccess';
import ChatInterface from './components/ChatInterface';
import config from './config';

// Component to handle automatic redirection for signed-in users
function RedirectOnAuth() {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSignedIn) {
      navigate('/home', { replace: true });
    }
  }, [isSignedIn, navigate]);

  return null;
}

// Wrapper component to check if coming from Stripe
function StripeRedirectHandler() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const sessionId = params.get('session_id');

  // Check if we have a Stripe session ID
  if (sessionId) {
    console.log("Detected Stripe session ID:", sessionId);
    return <StripeSuccess />;
  }

  // Show the LoginSuccess component to welcome the user
  return <LoginSuccess />;
}

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <SignedOut>
                  <LandingPage />
                </SignedOut>
                <SignedIn>
                  <Navigate to="/home" replace />
                </SignedIn>
              </>
            }
          />
          <Route
            path="/login-success"
            element={
              <SignedIn>
                <StripeRedirectHandler />
              </SignedIn>
            }
          />
          <Route
            path="/home"
            element={
              <SignedIn>
                <ChatInterface />
              </SignedIn>
            }
          />
          <Route
            path="/sign-in/*"
            element={
              <>
                <SignedOut>
                  <RedirectToSignIn />
                </SignedOut>
                <SignedIn>
                  <Navigate to="/home" replace />
                </SignedIn>
              </>
            }
          />
          {/* Handle Flask routes - these will be intercepted before reaching React */}
          <Route path="/login" element={<Navigate to="/sign-in" replace />} />
          <Route path="/auth/clerk" element={<Navigate to="/sign-in" replace />} />
          <Route path="/authorize" element={<Navigate to="/home" replace />} />

          {/* Direct route for Stripe success without redirects */}
          <Route path="/stripe-success" element={<SignedIn><StripeSuccess /></SignedIn>} />

          {/* Catch-all routes for GitHub Codespaces URLs with /react prefix */}
          <Route path="/react" element={<Navigate to="/" replace />} />
          <Route path="/react/stripe-success" element={<Navigate to="/stripe-success" replace />} />
          <Route path="/react/login-success" element={<Navigate to="/home" replace />} />
          <Route path="/react/*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;